/** Renders a span of seconds as a short readable duration, coarsening as it grows. */
export const formatDuration = (seconds: number | null | undefined): string => {
  const total = Number(seconds);
  if (seconds === null || seconds === undefined || Number.isNaN(total)) return "—";

  const whole = Math.max(0, Math.floor(total));
  if (whole < 60) return `${whole}s`;

  const days = Math.floor(whole / 86400);
  const hours = Math.floor((whole % 86400) / 3600);
  const minutes = Math.floor((whole % 3600) / 60);

  const parts: string[] = [];
  if (days) parts.push(`${days}d`);
  if (hours) parts.push(`${hours}h`);
  if (minutes && !days) parts.push(`${minutes}m`);

  return parts.join(" ");
};

export default formatDuration;
